import React from 'react';
import { Leaf, Sprout, Award, Recycle } from 'lucide-react';
import { benefits } from '../data/mock';

const iconMap = {
  Leaf: Leaf,
  Sprout: Sprout,
  Award: Award,
  Recycle: Recycle
};

export const Benefits = () => {
  return (
    <section
      id="benefits"
      className="py-20 relative"
      style={{ backgroundColor: '#5e3a1c' }}
    >
      <div
        className="absolute inset-0 opacity-15"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1586753080433-3b98668a4085)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed'
        }}
      />
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2
            className="text-4xl md:text-5xl font-bold mb-4"
            style={{ 
              color: '#f5e9d0',
              fontFamily: 'Georgia, serif'
            }}
          >
            The Mudbutt Difference
          </h2>
          <p className="text-lg max-w-2xl mx-auto" style={{ color: '#c2a357' }}>
            Rooted in quality, sustainability, and artisanal tradition
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit, index) => {
            const Icon = iconMap[benefit.icon];
            return (
              <div
                key={index}
                className="text-center p-8 rounded-lg backdrop-blur-sm hover:backdrop-blur-md transition-all duration-300 border-2"
                style={{
                  backgroundColor: 'rgba(139, 92, 47, 0.2)',
                  borderColor: '#c2a357'
                }}
              >
                <div
                  className="inline-flex items-center justify-center w-16 h-16 rounded-full mb-6 border-2"
                  style={{ backgroundColor: '#8b5c2f', borderColor: '#c2a357' }}
                >
                  <Icon className="w-8 h-8" style={{ color: '#f5e9d0' }} />
                </div>
                <h3
                  className="text-xl font-bold mb-3"
                  style={{ color: '#f5e9d0' }}
                >
                  {benefit.title}
                </h3>
                <p style={{ color: '#c2a357' }}>{benefit.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
